import { render, staticRenderFns } from "./item-gallery-mobile.vue?vue&type=template&id=15a1d5ca&scoped=true"
import script from "./item-gallery-mobile.vue?vue&type=script&lang=js"
export * from "./item-gallery-mobile.vue?vue&type=script&lang=js"
import style0 from "./item-gallery-mobile.vue?vue&type=style&index=0&id=15a1d5ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a1d5ca",
  null
  
)

export default component.exports